import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  sanitize() {
    const raw = this.inputTarget.value
    const cleaned = raw
      .split(/[\r\n,;]+/)
      .map(s => s.trim())
      .filter(s => s.length > 0)
      .filter((v, i, a) => a.indexOf(v) === i)
      .join("\n")

    this.inputTarget.value = cleaned
  }
}
